export default "__VITE_ASSET__DfeTBzTL__"